import React from 'react';
import { Title, Text, Button, Stack, Paper } from '@mantine/core';
import { IconUserOff, IconAlertCircle, IconArrowRight } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useGPTStore } from '@/store';

export const DisabledUserView: React.FC = () => {
  const { t } = useTranslation();
  const { setAssetScope } = useGPTStore((state) => state);

  const handleSwitchToPersonal = () => {
    setAssetScope(null);
  };

  return (
    <div className="flex items-center justify-center h-full">
      <Paper radius="lg" className="max-w-md w-full border border-gray-200 p-10">
        <Stack align="center" gap="md">
          <div className="w-14 h-14 rounded-xl bg-red-50 flex items-center justify-center">
            <IconUserOff size={26} stroke={1.5} color="var(--mantine-color-red-6)" />
          </div>

          <Stack align="center" gap={4}>
            <Title order={4} ta="center">
              {t('adminConsole.disabledOrg.title')}
            </Title>
            <Text c="dimmed" ta="center" size="sm">
              {t('adminConsole.disabledOrg.description')}
            </Text>
          </Stack>

          <Stack gap={8} className="w-full">
            <div className="flex items-center gap-2.5 px-3 py-2.5 rounded-md bg-gray-50">
              <IconAlertCircle size={16} stroke={1.5} color="var(--mantine-color-red-5)" className="flex-shrink-0" />
              <Text size="xs" c="gray.6">
                {t('adminConsole.disabledOrg.contactAdmin')}
              </Text>
            </div>
          </Stack>

          <Button
            color="violet"
            variant="light"
            radius="md"
            fullWidth
            rightSection={<IconArrowRight size={16} />}
            onClick={handleSwitchToPersonal}
          >
            {t('adminConsole.disabledOrg.switchToPersonal')}
          </Button>
        </Stack>
      </Paper>
    </div>
  );
};

export default DisabledUserView;
